import axiosInstance from "./axiosInstance";

export const getClientsList = () => {
  return axiosInstance.get(`/corporation/clients`);
};

export const getClient = (id) => {
  return axiosInstance.get(`/corporation/client/${id}`);
};

export const createClient = (params) => {
  return axiosInstance.post(`/corporation/client/add`, params);
};

export const updateClient = (id, params) => {
  return axiosInstance.post(`/corporation/client/update/${id}`, params);
};

export const deleteClient = (id) => {
  return axiosInstance.post(`/corporation/client/delete/${id}`);
};

export const importClients = (rows) => {
  return axiosInstance.post(`/corporation/client/import`, { rows });
};
